import React from 'react'
import AcoesPedido from './../AcoesPedido';
import DetalhesPedido from './../DetalhesPedido';
import ReactTooltip from 'react-tooltip';
import capitalizarTodasPrimeirasLetras from '../../../util/capitalizarTodasPrimeirasLetras';

export class PedidoGeral extends React.Component {
  getPedidoBadgeClass (situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s.includes('APROVADO') || s.includes('CONFIRMADO') || s.includes('PAGO')) return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('RECUSADO')) return 'vx-gp-badge--cancelado';
    if (s.includes('PENDENTE') || s.includes('ABERTO') || s.includes('AGUARDANDO')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibeDataHoraPartida (pedido, tipo, ehIdaVolta) {
    var datas = null;
    if (ehIdaVolta) {
      const reservas = this.groupArrayOfObjects(pedido.reservas, 'dataHoraPartida');
      const keys = Object.keys(reservas);
      var dataVolta = null;
      var dataIda = null;
      for (let i = 0; i < keys.length; i++) {
        keys.forEach((data) => {
          if (keys[i] > data) dataVolta = keys[i];
          if (keys[i] < data) dataIda = keys[i];
        });
      }
      if (tipo === 'IDA') return dataIda;
      if (tipo === 'VOLTA') return dataVolta;
    }
    if (!ehIdaVolta) {
      pedido.reservas.forEach((it) => { datas = it.dataHoraPartida; });
      return datas;
    }
  }

  exibirTooltipIdaVolta (pedido) {
    const ehIdaVolta = Object.entries(
      this.groupArrayOfObjects(pedido.reservas, 'itinerarioId')
    ).length > 1;

    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for={`data-embarque-${pedido.id}`}>
          <i className="material-icons">{ehIdaVolta ? 'sync_alt' : 'arrow_forward'}</i>
        </a>
        <ReactTooltip id={`data-embarque-${pedido.id}`} type="dark" effect="solid">
          <div>Ida: {this.exibeDataHoraPartida(pedido, 'IDA', ehIdaVolta)}</div>
          {ehIdaVolta && <div>Volta: {this.exibeDataHoraPartida(pedido, 'VOLTA', ehIdaVolta)}</div>}
        </ReactTooltip>
      </span>
    );
  }

  recuperaFormaPagamento () {
    let labelCartao = '';
    const linkPagamento = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Link Pagamento').length > 0;
    const cieloEcommercePix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cielo Pix').length > 0;
    const sicoobPix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Sicoob PIX').length > 0;
    const stonePix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Stone Connect').length > 0;
    let cartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão').length > 0;
    const cartaoCredito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de crédito').length > 0;
    const cartaoDebito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de débito').length > 0;
    const tef = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'TEF').length > 0;
    cartao = cartao || cartaoCredito || cartaoDebito || tef;
    if (cartao) {
      labelCartao = this.props.pedido.formasPagamentoDto.filter(it =>
        it.tipo === 'Cartão' || it.tipo === 'Cartão de crédito' || it.tipo === 'Cartão de débito' || it.tipo === 'TEF'
      )[0].tipo;
      if (labelCartao === 'TEF') labelCartao = 'Cartão/TEF';
    }
    const dinheiro = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro').length > 0;
    const pix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX').length > 0;
    if (cartao && dinheiro && pix) return `${labelCartao}, Dinheiro e PIX`;
    if (cartao && dinheiro) return `${labelCartao} e Dinheiro`;
    if (cartao && pix) return `${labelCartao} e PIX`;
    if (dinheiro && pix) return 'Dinheiro e PIX';
    if (dinheiro) return 'Dinheiro';
    if (cartao) return labelCartao;
    if (pix) return 'PIX';
    if (linkPagamento) return 'Link Pagamento';
    if (cieloEcommercePix) return 'Cielo Pix';
    if (sicoobPix) return 'Sicoob PIX';
    if (stonePix) return 'Stone Connect';
    return 'Não informado';
  }

  exibirIconeSituacaoReserva (pedido) {
    let situacoes = '';
    this.props.pedido.reservas.forEach((reserva, index) => {
      situacoes += `${index > 0 ? ' | ' : ''}${capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_', ' '))}`;
    });
    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for={`situacao-reserva-${pedido.id}`}>
          <i className="material-icons">info</i>
        </a>
        <ReactTooltip id={`situacao-reserva-${pedido.id}`} type="dark" effect="solid">
          Situação(ões): {situacoes}
        </ReactTooltip>
      </span>
    );
  }

  render () {
    const { pedido } = this.props;
    const isOpen = pedido.exibirDetalhe;

    return (
      <div className={`vx-gp-row${isOpen ? ' vx-gp-row--open' : ''}`}>
        <div className="vx-gp-row-main vx-gp-row-main--geral" onClick={() => this.props.alterarExibicao(pedido)}>

          <div className="vx-gp-toggle">
            <span className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</span>
          </div>

          {/* Pedido + tooltip de datas de partida */}
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Pedido</span>
            <span className="vx-gp-field-value" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              #{pedido.id}
              {this.exibirTooltipIdaVolta(pedido)}
            </span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Empresa</span>
            <span className="vx-gp-field-value">{pedido.nomeFantasiaEmpresa}</span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Vendedor</span>
            <span className="vx-gp-field-value">{pedido.nomeVendedor}</span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Cliente</span>
            <span className="vx-gp-field-value">{pedido.nomeComprador}</span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data</span>
            <span className="vx-gp-field-value">{pedido.data}</span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Situação</span>
            <span className={`vx-gp-badge ${this.getPedidoBadgeClass(pedido.situacaoPedido)}`}>
              {pedido.situacaoPedido}
            </span>
            {this.exibirIconeSituacaoReserva(pedido)}
          </div>

          <div className="vx-gp-field vx-gp-field--price">
            <span className="vx-gp-field-label">Valor</span>
            <span className="vx-gp-field-value">
              {Number(pedido.valorTotalReservas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>

          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Pagamento</span>
            <span className="vx-gp-field-value">{this.recuperaFormaPagamento()}</span>
          </div>

          <div className="vx-gp-field--actions" onClick={e => e.stopPropagation()}>
            <AcoesPedido
              pedido={pedido}
              empresaSelecionada={this.props.empresaSelecionada}
              valoresDdiPassageiro={this.props.valoresDdiPassageiro}
              adicionarValoresDdiPassageiro={this.props.adicionarValoresDdiPassageiro}
              removerValoresDdiPassageiro={this.props.removerValoresDdiPassageiro}
              limparValoresDdiPassageiro={this.props.limparValoresDdiPassageiro}
            />
          </div>

        </div>
        <DetalhesPedido pedido={pedido}/>
      </div>
    );
  }
}

export default PedidoGeral;
